<template>
	<DialogPanel class="transcription-upload-prompt-panel"
		footer-type="TRANSPARENT"
		:scroll-body="true"
		@close="$emit( `close` )"
	>
		<template #sub-header>
			<header class="header">
				<div class="title-glyphs">
					<FontAwesomeIcon :icon="[ `far`, `file-video` ]" />
					<FontAwesomeIcon :icon="[ `far`, `file-audio` ]" />
					<FontAwesomeIcon :icon="[ `far`, `chevrons-right` ]" />
					<FontAwesomeIcon :icon="[ `far`, `file-lines` ]" />
				</div>
				<div class="title">
					<h1 class="title-text">{{ translate( `title` ) }}</h1>
				</div>
			</header>
		</template>
		<template #body>
			<section class="content" v-html="translate( `bodyContent` )"></section>
		</template>
		<template #footer>
			<div class="sub-footer">
				<div class="footer-buttons">
					<TeamingButton2
						size="SMALL"
						@click="$emit( `confirm` )"
					>
						{{ translate( `uploadRecordingButton` ) }}
					</TeamingButton2>
					<TeamingButton2
						size="SMALL"
						type="TERTIARY"
						:borderless="true"
						@click="$emit( `cancel` )"
					>
						{{ translate( `notNowButton` ) }}
					</TeamingButton2>
				</div>
				<div class="footer-options">
					<TeamingCheckbox
						name="doNotShow"
						:is-checked="doNotShowChecked"
						@change="onDoNotShowChanged"
					/>
					<label class="do-not-show-label">{{ translate( `doNotShowLabel` ) }}</label>
				</div>
			</div>
		</template>
	</DialogPanel>
</template>

<script>
import {
	DialogPanel,
	TeamingButton2,
	TeamingCheckbox,
	TranslateMixin
} from "@teaming/common-ui";

export default {
	name: "TranscriptionUploadPromptPanel",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "confirm", "cancel", "changeSettings", "close", ],
	components: {
		DialogPanel,
		TeamingButton2,
		TeamingCheckbox,
	},
	data() {
		return {
			doNotShowChecked: false,
		};
	},
	methods: {
		onDoNotShowChanged( e ) {
			this.doNotShowChecked = e.isChecked;
			this.$emit( "changeSettings", { showTranscriptionInterstitial: !e.isChecked, } );
		},
	},
};
</script>

<style lang="scss" scoped>
$glyphColor: $color1-500;
$titleColor: $color1-700;

.transcription-upload-prompt-panel {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 2rem;
}

.transcription-upload-prompt-panel .header {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	padding-top: 2rem;
}

.transcription-upload-prompt-panel .title-glyphs {
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1rem;

	color: $glyphColor;
	@include font-and-line-for(5);
	font-weight: 600;
}

.transcription-upload-prompt-panel .title {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
}

.transcription-upload-prompt-panel .title-text {
	color: $titleColor;
	@include font-and-line-for(2);
	font-weight: 600;
}

.transcription-upload-prompt-panel .sub-body {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}

.transcription-upload-prompt-panel .content {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1.5rem;

	@include font-and-line-for(0);
	font-weight: 450;

	padding: 0 1.5rem;
}

.transcription-upload-prompt-panel .sub-footer {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.transcription-upload-prompt-panel .footer-buttons,
.transcription-upload-prompt-panel .footer-options {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}

.transcription-upload-prompt-panel .do-not-show-label {
	@include font-and-line-for(0);
}
</style>
